import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';

import { Box } from '../Box';
import { Text } from '../Text';
import { Column } from '../Layout';
import { GlImage, GlImageProps } from '../Image';

interface Props extends GlImageProps {
  currentImage: boolean;
}

export const ImageWrapper = styled('div')`
  position: relative;
  width: 100%;
`

export const StyledImage = styled(GlImage, {
  shouldForwardProp: (prop) => prop !== 'currentImage'
})<Props>`
  max-width: 100%;
  margin: 0 auto;
  border-radius: ${({ theme }) => theme.borderRadius.block};
  flex-grow: 1;
  display: ${({ currentImage }) => (currentImage ? 'block' : 'none')};
  z-index: 0;

  ${mediaQueries.desktop} {
    max-width: 480px;
    border-radius: ${({ theme }) => theme.borderRadius.block_desktop};
    margin-right: ${({ theme }) => theme.spacing.m};
  }
`;

export const StoryColumn = styled(Column)`
  margin-top: ${({ theme }) => theme.spacing.m};

  ${mediaQueries.tablet} {
    flex-grow: 1;
    margin-top: 0;
  }
  ${mediaQueries.desktop} {
    flex-grow: 0;
  }
`;

export const StoryBox = styled(Box)`
  ${mediaQueries.tablet} {
    flex-grow: 1;
  }
`;

export const MaxWidthHeading = styled(Text)`
  max-width: ${pxToRem(390)};

  ${mediaQueries.tablet} {
    padding-bottom: ${({ theme }) => `${theme.spacing.xs}`};
  }

  ${mediaQueries.desktop} {
    padding-bottom: ${({ theme }) => `${theme.spacing.s}`};
  }
`;

export const StorytellingButton = styled('div')`
  margin-top: -${({ theme }) => `${theme.spacing.l}`};
`;
